import React, { useContext, useEffect, useState } from 'react'
import { Container } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import TagManager from 'react-gtm-module'
import Loans from '../loans/Loans'
import Deposits from '../deposits/Deposits'
import { checkIsMobile, setVocative } from 'utils/helpers'
import { CookieType } from '../../constants/cookieTypes'
import { OutOfServiceModal } from '../../components/modals/OutOfServiceModal'
import { appRoutes } from '../../constants/routes/Routes'
import AppConfigContext from 'contexts/azureAppConfig'
import { KycWrapper } from '../../components/modals/KycSharedModal/KycModal'
import i18next from 'i18next'
import { useNavigate } from 'react-router'
import { CircleSpinner } from 'exports'
import appConfig from 'app.config'

function HomePage() {
	const [userName, setUserName] = useState<string>()
	const navigate = useNavigate()
	// this is a crappy solution, but all i could think of when fetching from cookies
	useEffect(() => {
		function setUserNameFunc(retriesLeft: number) {
			if (userName || retriesLeft === 0) return

			const nameFromCookie = sessionStorage
				.getItem(CookieType.CustomerName)
				?.toString()

			if (!nameFromCookie) {
				const newRetriesLeft = retriesLeft - 1
				setTimeout(setUserNameFunc, 500, newRetriesLeft)
				return
			}

			let tempUserName = JSON.parse(nameFromCookie!) as string
			setUserName(tempUserName)
		}

		setTimeout(setUserNameFunc, 500, 10)
	}, [i18next.language]) //eslint-disable-line

	const isMobile = checkIsMobile()
	const { t } = useTranslation()

	const [loans, setLoans] = useState<{
		hasValue: boolean
		hasError?: Error
	}>({
		hasValue: true,
		hasError: undefined,
	})

	const [deposits, setDeposits] = useState<{
		hasValue: boolean
		hasError?: Error
	}>({
		hasValue: true,
		hasError: undefined,
	})
	const { ready } = useContext(AppConfigContext)

	const tagManagerArgs = {
		dataLayer: {
			userId: '001',
			userProject: 'project',
			page: '/home',
		}
	}

	React.useEffect(() => {
		TagManager.dataLayer(tagManagerArgs)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	return (
		<React.Fragment>
			{ready ? (
				<div className="container-fluid p-0 home-page">
					<Container className="px-0 bg">
						{appConfig.country !== 'no' && <KycWrapper />}
						<Container className={isMobile ? 'pt-5' : ''}>
							<OutOfServiceModal
								showModal={
									!loans.hasValue && !deposits.hasValue
								}
								onClick={() => {
									navigate(appRoutes.logout)
								}}
								icon={
									loans.hasError || deposits.hasError
										? undefined
										: 'search-dollar'
								}
								message={
									loans.hasError || deposits.hasError
										? 'Network Error'
										: t('NoAccounts')
								}
								color="#5b7f95"
							/>

							<h2 className="mb-2 top-title">
								{t('Hello')}{' '}
								{userName ? (
									<>
										{i18next.language === 'lt'
											? setVocative(userName)
											: userName}
										!
									</>
								) : null}
							</h2>

							<Loans
								onChangeValues={(
									hasValue: boolean,
									hasError?: Error
								) => {
									setLoans({ hasValue, hasError })
								}}
							/>
							 {appConfig.country !== 'no' && (
                                <Deposits
                                    onChangeValues={(hasValue: any, hasError: any) => setDeposits({ hasValue, hasError })}
                                />
                            )}
						</Container>
					</Container>
				</div>
			) : (
				<CircleSpinner />
			)}
		</React.Fragment>
	)
}

export default HomePage